import { inject, observer } from "mobx-react";

import { Card } from "primereact/card";

import { Button } from "primereact/button";

import "./style.scss";
import CopyTagUI from "@UI/CopyTagUI";
import { useEffect, useState } from "react";

const RangingPage = inject("mainStore")(
    observer(({ mainStore }) => {
        const [show, setShow] = useState(false);
        const [disable, setDisable] = useState(false);

        useEffect(() => {
            const handler = setTimeout(() => {
                setShow(false);
                setDisable(false);
            }, 5000);

            return () => {
                clearTimeout(handler);
            };
        }, [show]);

        const handleRanging = async () => {
            setDisable(true);
            const resp = await mainStore.getByUrl("promo/runAutorange", false, "", false, false);

            if (resp && resp.success) {
                setShow((prev) => !prev);
            }
        };

        return (
            <div className="ranger">
                <Card title="Ранжирование">
                    {show ? <CopyTagUI label="Ранжирование обновлено" icon="pi-check" className="notification" /> : null}
                    <Button label={"Ранжироваться"} severity={"success"} onClick={handleRanging} disabled={disable} />
                </Card>
            </div>
        );
    }),
);

export default RangingPage;
